module.exports = __webpack_public_path__ + "media/images/countrysquared/rs-c2548dc9a424a4b7badf0e889418be6c.svg";